<template>
	<div
		class="full-modal modal-flex modal-transparent booking-confirmed-modal"
		v-bind:class="{ 'modal-show': ui.showConfirmationModal }"
	>
		<div class="modal-body modal-wide bg-primary">
			<a
				@click.prevent="closeModal()"
				href="#"
				class="modal-close link-close-right"
			></a>
			<div class="row">
				<div class="col-xs-10 col-md-4">
					<h1 class="margin-top-xs-0 margin-bottom-xs-1">
						Tack för din bokning!
					</h1>
				</div>
				<div class="col-xs-12 col-md-8 padding-bottom-md-5">
					<h3 class="margin-top-xs-0 margin-bottom-xs-1">
						Vi kommer att skicka en bokningsbekräftelse till din
						angivna e-postadress.
					</h3>
					<section
						class="
							booking-details
							margin-bottom-xs-2 margin-bottom-md-0
						"
						v-if="activities.selected"
					>
						<p class="margin-bottom-xs-0">Din bokning:</p>
						<p
							class="margin-bottom-xs-0"
							v-html="activities.selected.activity_name"
						></p>
						<p
							class="margin-bottom-xs-0"
							v-html="
								selectedSlot.date +
								' klockan ' +
								selectedSlot.time
							"
						></p>
						<p
							class="margin-bottom-xs-0"
							v-html="selectedSlot.location_name"
						></p>
						<p
							class="margin-bottom-xs-0"
							v-html="
								formatProviderNameInList(
									selectedSlot.terapeut_sign
								)
							"
						></p>
					</section>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
	computed: {
		...mapState(["ui", "booking", "selectedSlot", "activities"]),
	},
	methods: {
		...mapActions(["prepareNewBooking"]),
		closeModal() {
			this.$store.state.ui.showConfirmationModal = false;
			this.prepareNewBooking(); // Prepare a new booking by clearing all data related to the current booking etc.
		},
		formatProviderNameInList(name) {
			if (name) {
				return this.$store.getters.formatProviderNameInList(name);
			}
			return "";
		},
	},
};
</script>